import React, { useMemo, useState } from 'react'
import { MultiSelect, NormalizedDropdownItemType } from '@entur/dropdown'
import { getRules } from '../../api-clients/eba-clients'
import { useApiOnLoad } from '../../api-clients/client-hooks'
import { FetchState, SimpleRule } from '../../api-clients/api-types'
import { FormField } from '../../utils/form-utils'

export const ruleFormField = (value?: string, displayValue?: string): FormField<string | undefined> => {
  return {
    value,
    displayValue,
    fieldName: 'ruleId',
    displayName: 'Regel',
  }
}

const ruleToDropdownItemType = (rule: SimpleRule): NormalizedDropdownItemType => {
  return { label: rule.name, value: rule.id.toString() }
}

const formValueSeparator = ',' // query params: ?ruleId=1,2,3
const getFormValue = (event: NormalizedDropdownItemType[]): string =>
  event.map((dropdownItem) => dropdownItem.value).join(formValueSeparator)

const displayValueSeparator = '|' // name can contain comma
const getFormDisplay = (event: NormalizedDropdownItemType[]): string =>
  event.map((dropdownItem) => dropdownItem.label).join(displayValueSeparator)

const getDropdownItemsFromForm = (form: FormField<string | undefined>): NormalizedDropdownItemType[] => {
  if (form && form.value && form.value.length > 0) {
    const values = form.value.split(formValueSeparator) ?? []
    const names = form.displayValue?.split(displayValueSeparator) ?? []
    return Object.assign(
      values.map((value, index) => ({
        value,
        label: names[index],
      }))
    )
  }
  return []
}

type RuleDropdownProps = {
  rules: FormField<string | undefined>
  placeholder: string
  update: (value: FormField<string | undefined>) => void
}
const RuleDropdown: React.FC<RuleDropdownProps> = (props) => {
  const [response] = useApiOnLoad(getRules, {})
  const [selected, setSelected] = useState(getDropdownItemsFromForm(props.rules))

  const companies = useMemo(
    () =>
      response.status === FetchState.SUCCESS
        ? () => [...response.data].sort((a, b) => a.name.localeCompare(b.name)).map(ruleToDropdownItemType)
        : [],
    [response]
  )

  const onChange = (event: NormalizedDropdownItemType[] | null) => {
    if (event && event !== selected) {
      setSelected(event)
      props.update(ruleFormField(getFormValue(event), getFormDisplay(event)))
    }
  }

  return (
    <MultiSelect
      className="ruleDropdown"
      style={{ cursor: 'pointer' }}
      placeholder={props.placeholder}
      items={companies}
      onChange={onChange}
      selectedItems={selected}
      label={props.placeholder}
      hideSelectAll
    />
  )
}

export default RuleDropdown
